module.exports = __webpack_public_path__ + "static/media/uiux.3aae3287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/uiux.jpg
// module id = 196
// module chunks = 0